import React, { useMemo } from 'react';
import type { HotelProposalReasons } from '../../../types/hotelProposalReasons';
import { filterHotelItems, type HotelProposalBundle } from '../../../types/proposalBundles';
import HotelItemsTable from './HotelItemsTable';
import HotelRecommendationReasonsSection from './HotelRecommendationReasonsSection';

interface Props {
  bundle: HotelProposalBundle;
  includeTax: boolean;
  disabled: boolean;
  isSpLayout: boolean;
  onSelect: (itemId: number) => void;
  onOpenDetail: (itemId: number) => void;
  reasons: HotelProposalReasons;
}

const SingleHotelCard = ({ bundle, includeTax, disabled, isSpLayout, onSelect, onOpenDetail, reasons }: Props) => {
  const hotelItems = useMemo(() => filterHotelItems(bundle.items), [bundle.items]);
  const stayDays = bundle.route.stayDays ?? null;
  const priceHeaderNote = stayDays && stayDays > 0 ? `（${stayDays}泊合計）` : '（1泊1室）';

  return (
    <>
      <HotelItemsTable
        items={hotelItems}
        includeTax={includeTax}
        bundleStayDays={stayDays}
        priceHeaderNote={priceHeaderNote}
        disabled={disabled}
        onSelect={onSelect}
        onOpenDetail={onOpenDetail}
        isSpLayout={isSpLayout}
      />
      <HotelRecommendationReasonsSection items={hotelItems} reasons={reasons} />
    </>
  );
};

export default SingleHotelCard;
